import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EngagementsAccept extends ApplicationRecord {
  static jsonapiType = "engagements/accept";

  @Attr() engagementId: number;

  @Attr() employerUserId: number;
}

export default EngagementsAccept;
